

<template>
    <div :class="`toggle${invert ? ' toggle--invert' : ''}`">
        <label v-if="uncheckedLabel" :for="id">{{ uncheckedLabel }}</label>
        <input type="checkbox" class="toggle-input" :id="id" v-model="value" v-on:change="onChange" />
        <label :for="id" class="toggle-label"></label>
        <label v-if="checkedLabel" :for="id">{{ checkedLabel }}</label>
    </div>
</template>

<script>
    export default {
        props: ['uncheckedLabel', 'checkedLabel', 'originalValue', 'id', 'invert'],
        data() {
            return {
                value: this.originalValue
            }
        },
        watch: {
            originalValue(newVal) {
                if (typeof newVal === "boolean") {
                    this.value = newVal;
                    return;
                }

                this.value = false;
            }
        },
        methods: {
            onChange() {
                this.$emit('onValueChanged', this.value);
            }
        }
    }
</script>
